import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Reveal, MaskedLine } from "../components/Reveal";
import { useLang } from "../i18n/LanguageContext";

const EMPTY = { nome: "", email: "", telefono: "", paese: "", argomento: "Informazioni", messaggio: "" };

export default function Contatti() {
  const { t } = useLang();
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const ARGOMENTI = [
    { value: "Informazioni", label: t("ct_arg1") },
    { value: "Partecipazione", label: t("ct_arg2") },
    { value: "Programma Partner", label: t("ct_arg3") },
    { value: "Assistenza", label: t("ct_arg4") },
  ];

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", { ...form, telefono: form.telefono || undefined });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="contatti-page">
      <section className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-20 pb-20 lg:pt-28 lg:pb-28 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5 min-w-0">
          <MaskedLine delay={0.1}><span className="eyebrow">{t("ct_eyebrow")}</span></MaskedLine>
          <h1 className="mt-8 text-4xl sm:text-5xl lg:text-6xl leading-[1.08]" data-testid="contatti-title">
            <MaskedLine delay={0.25}><><em className="italic text-gold">{t("ct_title")}</em>.</></MaskedLine>
          </h1>
          <Reveal delay={0.4}>
            <p className="mt-8 text-lg text-ink-muted leading-relaxed max-w-md">{t("ct_text")}</p>
          </Reveal>
        </div>
        <div className="lg:col-span-7 min-w-0">
          <Reveal delay={0.2}>
            {sent ? (
              <div className="card-surface p-10 sm:p-14 border-s-2 !border-s-gold" data-testid="contact-success">
                <p className="font-serif text-3xl text-ink">{t("ct_ok_t")}</p>
                <p className="mt-4 text-lg text-ink-muted leading-relaxed">{t("ct_ok_x")}</p>
              </div>
            ) : (
              <form onSubmit={submit} className="card-surface p-8 sm:p-12 grid sm:grid-cols-2 gap-6" data-testid="contact-form">
                <div>
                  <label htmlFor="c-nome" className="block text-xs font-semibold uppercase tracking-[0.2em] text-ink-muted mb-2">{t("ct_nome")}</label>
                  <input id="c-nome" className="input-field" required value={form.nome} onChange={set("nome")} data-testid="contact-nome" autoComplete="name" />
                </div>
                <div>
                  <label htmlFor="c-email" className="block text-xs font-semibold uppercase tracking-[0.2em] text-ink-muted mb-2">{t("ct_email")}</label>
                  <input id="c-email" type="email" className="input-field" required value={form.email} onChange={set("email")} data-testid="contact-email" autoComplete="email" />
                </div>
                <div>
                  <label htmlFor="c-telefono" className="block text-xs font-semibold uppercase tracking-[0.2em] text-ink-muted mb-2">{t("ct_tel")}</label>
                  <input id="c-telefono" type="tel" className="input-field" value={form.telefono} onChange={set("telefono")} data-testid="contact-telefono" autoComplete="tel" />
                </div>
                <div>
                  <label htmlFor="c-paese" className="block text-xs font-semibold uppercase tracking-[0.2em] text-ink-muted mb-2">{t("ct_paese")}</label>
                  <input id="c-paese" className="input-field" required value={form.paese} onChange={set("paese")} data-testid="contact-paese" autoComplete="country-name" />
                </div>
                <div className="sm:col-span-2">
                  <label htmlFor="c-argomento" className="block text-xs font-semibold uppercase tracking-[0.2em] text-ink-muted mb-2">{t("ct_arg")}</label>
                  <select id="c-argomento" className="input-field" value={form.argomento} onChange={set("argomento")} data-testid="contact-argomento">
                    {ARGOMENTI.map((a) => <option key={a.value} value={a.value}>{a.label}</option>)}
                  </select>
                </div>
                <div className="sm:col-span-2">
                  <label htmlFor="c-messaggio" className="block text-xs font-semibold uppercase tracking-[0.2em] text-ink-muted mb-2">{t("ct_msg")}</label>
                  <textarea id="c-messaggio" rows={6} className="input-field resize-y" required minLength={10} value={form.messaggio} onChange={set("messaggio")} data-testid="contact-messaggio" />
                </div>
                <div className="sm:col-span-2">
                  <button type="submit" className="btn-primary w-full sm:w-auto disabled:opacity-60" disabled={sending} data-testid="contact-submit">
                    {sending ? t("ct_sending") : t("ct_submit")}
                  </button>
                </div>
              </form>
            )}
          </Reveal>
        </div>
      </section>
    </div>
  );
}
